module.exports = __webpack_public_path__ + "img/close.4574992b.svg";